<template>
  <div>
    <ui-modal
      ref="modal"
      @close="ActionSetVisibleModalEditarSubSeccion(false)"
      :title="`Actualizar Sub Sección - ${titulo}`"
      size="large"
    >
      <div class="d-flex">
        <ui-textbox
          floating-label
          label="Nombre"
          v-model="nombreModel"
          class="w-50 mr-3"
        />
        <ui-textbox
          floating-label
          label="Referencia"
          v-model="referenciaModel"
          class="w-50"
        />
      </div>
      <!-- row 1 -->
      <div class="d-flex">
        <ui-select
          class="w-50 mr-3"
          has-search
          label="Modulos"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="listaModulos"
          v-model="modulosModel"
          @change="filtrarSecciones(modulosModel)"
        />

        <ui-select
          class="w-50"
          has-search
          label="Sección"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="listaSeccionesAux"
          v-model="seccionesModel"
        />
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="actualizarSubSeccion">
          Guardar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";

// Constantes
import {
  updateSubSeccion,
  getSubSecciones,
} from "../../../../constants/superadministrador";

export default {
  props: ["data", "listaSecciones", "listaModulos"],

  data() {
    return {
      id: "",
      nombreModel: "",
      referenciaModel: "",
      modulosModel: [],
      seccionesModel: [],
      titulo: "",
      listaSeccionesAux: [],
      dataAux: this.data,
    };
  },

  components: {
    UiModal,
    UiTextbox,
    UiSelect,
  },

  computed: {
    ...mapState("superadministrador", ["visibleModalEditarSubSeccion"]),
  },

  methods: {
    ...mapActions("superadministrador", [
      "actionSetDataSubSecciones",
      "ActionSetVisibleModalEditarSubSeccion",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    filtrarSecciones(item, isEdit = true) {
      let secciones = this.listaSecciones.filter((seccion) => {
        return item.id == seccion.id_module;
      });

      this.listaSeccionesAux = secciones;

      if (isEdit) {
        secciones.length && (this.seccionesModel = secciones[0]);
      }
    },

    async actualizarSubSeccion() {
      let data = {
        id: this.id,
        name: this.nombreModel,
        id_parent: this.seccionesModel.id,
        name_reference: this.referenciaModel,
        id_module: this.modulosModel.id,
      };

      let sql = await updateSubSeccion(data);

      if (sql.data == 200) {
        this.$vToastify.success(
          "Subsección actualizada con éxito",
          "¡Realizado!"
        );

        this.nombreModel = "";
        this.referenciaModel = "";
        this.modulosModel = [];
        this.seccionesModel = [];

        let dataSubSeccionesDB = await getSubSecciones();
        this.dataAux = dataSubSeccionesDB;

        this.actionSetDataSubSecciones(dataSubSeccionesDB.data_table);

        this.closeModal("modal");
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.error(
            "La subsección no ha podido actualizarse",
            "¡Error!"
          );
        }
      }
    },
  },

  watch: {
    visibleModalEditarSubSeccion: function (_new) {
      _new && this.openModal("modal");
    },
    data: async function (_new) {
      console.log("new: ", _new);
      this.titulo = _new.data[0];

      this.id = _new.data_complementaria.id_seccion;
      this.nombreModel = _new.data[0];
      this.referenciaModel = _new.data[1];

      const seccion = { id: _new.data_complementaria.id_module };
      await this.filtrarSecciones(seccion, false);
      this.seccionesModel = {
        id: _new.data_complementaria.id_parent,
        name: _new.data_complementaria.name_subsection,
      };
      this.modulosModel = {
        id: _new.data_complementaria.id_module,
        name: _new.data[2],
      };
    },
  },
};
</script>
